<template>
    <resource-form :model="form.model"
        :schema="form.schema"
        :triggers="form.triggers"
        :no-form-group="true"
        @submit="onFormSubmit">
        <button type="button" slot="cancel" class="btn btn-default btn-sm" @click="onCancelButtonClick">
            Annuler
        </button>
    </resource-form>
</template>

<script>
    import ResourceForm from "components/Forms/ResourceForm"

    export default {
        data() {
            return {
                form: {
                    model: {},
                    schema: {
                        fields: [
                            {
                                "type": "email",
                                "label": "E-mail",
                                "model": "email",
                                "readonly": false,
                                "placeholder": "",
                                "disabled": false,
                                "hidden": false,
                                "help": "",
                                "hint": "",
                                "required": true
                            }
                        ],
                        optional_fields: []
                    },
                    triggers: {}
                }
            }
        },

        props: {
            user: {
                required: true
            }
        },

        components: {
            ResourceForm
        },

        created() {
            this.form.model = this.user
        },

        methods: {
            updateUserEmail(email) {
                return this.$root.axios.put(`users/${this.user.id}/update_email`, {email})
            },

            onFormSubmit({ data: model }) {
                this.updateUserEmail(model.email)
                    .then(() => {
                        this.$emit('email-updated')
                
                        // For modal handling
                        this.$parent.$emit('modal-closed')
                    })
            },

            onCancelButtonClick() {
                this.$emit('operation-canceled')
                
                // For modal handling
                this.$parent.$emit('modal-closed')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/components/Users/UserEmailUpdateForm.vue